var Clm = {

    init: function() {
        Clm.bindTutorGroupSelect();
        Clm.bindTermSelect();
        Clm.bindPupilSelect();
        //Clm.bindFrameworkSelect();
        Clm.bindAddClm();
        //Clm.bindEditClm();
        Clm.bindApplyClmToPupil();
        Clm.bindClmFrameworks();
        Clm.bindAddArea();
        Clm.bindClmSelect();
        Clm.bindAdminClmSelect();
        Clm.bindRemove();
        Clm.bindClmDelete();
        Clm.bindClmApply();
        Clm.bindClmCopy();
    },
    
    bindClmCopy: function() {
        $('#clm-copy').click(function() {
            var termId = $('#clm-terms').val();
            var tutorGroupId = $('#clm-tutor-groups').val();
            var pupilId = $('#clm-pupils').val();
            var clmId = $('#clms').val();
            var newTermId = $('#copy-term').val();
            var copy = confirm('Doing this will overwrite any existing CLM data for the target term, do you want to continue?');
            if (copy) {
                $.get('/clm/' + termId + '/' + tutorGroupId + '/' + pupilId + '/' + clmId + '/copy?term=' + newTermId, function(res) {
                    if (res['success']) {
                        alert('Copy successful!');
                    }
                });
            }
        });
    },

    bindClmDelete:function() {
        $('#clm-delete').click(function(e) {
            var href = $(this).attr('href');
            e.preventDefault();
            if (confirm('Are you sure you want to delete this Curriculum Learning Matrix along with all of its data?')) {
                window.location.href = href;
            }
        });
    },

    bindClmApply:function() {
        $('#applyClmSave').click(function(e) {
            if ($('.form-check-input:checked').length <= 0 ) {
                e.preventDefault();
                alert('Please select one or more statements before continuing.');
            }
        });
    },

    bindClmSelect: function() {
        $('#clms').on('change', function() {
            var select = $(this);
            var termId = $('#clm-terms').val();
            var tutorGroupId = $('#clm-tutor-groups').val();
            var pupilId = $('#clm-pupils').val();
            var clmId = select.val();
            var clmActive = select.find('option:selected').text().indexOf('✓') > 0;
            if (clmActive) {
                return window.location.href = '/clm/' + termId + '/' + tutorGroupId + '/' + pupilId + '/' + clmId;
            }
            window.location.href = '/clm/' + termId + '/' + tutorGroupId + '/' + pupilId + '/' + clmId + '/apply';
        });
    },

    toggleAddArea: function() {
        var addAreaBtn = $('#add-area');
        if ($('.area').length < 7) {
            addAreaBtn.removeClass('hidden');
            return false;
        }
        addAreaBtn.addClass('hidden');
    },

    bindRemove: function() {
        $('.clm-area-remove').click(function() {
            var areaCount = $('.area').length;
            if (areaCount > 1) {
                var btn = $(this);
                var areaId = btn.data('area');
                $('#' + areaId).remove();
            }
            Clm.toggleAddArea();
        });

        $('.clm-area-delete').click(function() {
            var btn = $(this);
            var areaId = btn.data('area');
            if (confirm('Are you sure you want to delete this item?')) {
                $.get('/clm-areas/' + areaId + '/delete', function(res) {
                    if (!res.success) {
                        alert('Action not successful. Please try again');
                        return false;
                    }
                    console.log(res.success);
                });
                $('#' + areaId).remove();
            }
            Clm.toggleAddArea();
        });
    },

    bindAdminClmSelect: function() {
        $('#admin-clms').on('change', function() {
            var clmId = $(this).val();
            window.location.href = '/admin/clm/' + clmId + '/edit'
        });
    },

    bindAddArea: function() {
        $('#add-area').click(function() {
            var areaCount = $('.area').length;
            var btn = $(this);
            if (areaCount >= 7) {
                btn.addClass('hidden');
                return false;
            }
            $.get('/clm-areas/', function(data) {
                $(data).insertBefore($('#add-area-row'));
                Clm.toggleAddArea();
                $('.select2').select2();
                Clm.bindClmFrameworks();
                Clm.bindRemove();
            });
        });
    },

    bindClmFrameworks: function() {
        $('.clm-framework').on('change', function() {
            var select = $(this);
            var areaId = select.data('area');
            var subjects = $('#' + areaId + '-subjects');
            subjects.find('option:not(:selected)').remove();
            var frameworkId = $(this).val();
            $.get('/frameworks/' + frameworkId + '/subjects', function(data) {
                subjects.select2({
                    data: data
                });
            });
        });
    },

    bindTermSelect: function() {
        $('#clm-terms').on('change', function() {
            var termId = $(this).val();
            var tutorGroupId = $('#clm-tutor-groups').val();
            var pupilId = $('#clm-pupils').val();
            window.location.href = '/clm/' + termId + '/' + tutorGroupId + '/' + pupilId;
        });
    },

    bindTutorGroupSelect: function() {
        $('#clm-tutor-groups').on('change', function() {
            var tutorGroupId = $(this).val();
            var termId = $('#clm-terms').val();
            window.location.href = '/clm/' + termId + '/' + tutorGroupId;
        });
    },

    bindPupilSelect: function() {
        $('#clm-pupils').on('change', function() {
            var pupilId = $(this).val();
            var termId = $('#clm-terms').val();
            var tutorGroupId = $('#clm-tutor-groups').val();
            window.location.href = '/clm/' + termId + '/' + tutorGroupId + '/' + pupilId;
        });
    },

    bindFrameworkSelect: function() {
        $('#clm-framework').on('change', function() {
            var frameworkId = $(this).val();
            $.get('/clm/activities/' + frameworkId, function(data) {
                $('#clm-activities').html(data);
            });
        });
    },

    bindAddClm: function() {
        $('#clm-add').click(function() {
            var tutorGroupId = $('#clm-tutor-groups').val();
            var termId = $('#clm-terms').val();
            window.location.href = '/clm/add/' + termId + '/' + tutorGroupId;
        });
    },

    bindEditClm: function() {
        $('#clm-edit').click(function() {
            var pupilId = $('#clm-pupils').val();
            var termId = $('#clm-terms').val();
            var tutorGroupId = $('#clm-tutor-groups').val();
            var clmId = $('#clms').val();
            window.location.href = '/clm/' + termId + '/' + tutorGroupId + '/' + pupilId + '/' + clmId +  '/edit';
        });
    },

    bindApplyClmToPupil: function () {
        $('#clm-apply').click(function () {
            var termId = $('#clm-terms').val();
            var tutorGroupId = $('#clm-tutor-groups').val();
            var pupilId = $('#clm-pupils').val();
            var clmId = $('#clms').val();
            window.location.href = '/clm/' + termId + '/' + tutorGroupId + '/' + pupilId + '/' + clmId +  '/apply';
        });
    }
}